<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="props.size" :background="props.background" viewBox="0 0 17 16">
    <path
      d="M5.00669 2.11641C5.00669 1.62967 5.40127 1.23509 5.88801 1.23509H15.5825C16.0693 1.23509 16.4638 1.62967 16.4638 2.11641C16.4638 2.60315 16.0693 2.99773 15.5825 2.99773H5.88801C5.40127 2.99773 5.00669 2.60315 5.00669 2.11641ZM0.600098 2.11641C0.600098 1.3863 1.19197 0.794434 1.92208 0.794434C2.65219 0.794434 3.24406 1.3863 3.24406 2.11641C3.24406 2.84652 2.65219 3.43839 1.92208 3.43839C1.19197 3.43839 0.600098 2.84652 0.600098 2.11641ZM0.600098 8.28565C0.600098 7.55554 1.19197 6.96367 1.92208 6.96367C2.65219 6.96367 3.24406 7.55554 3.24406 8.28565C3.24406 9.01576 2.65219 9.60763 1.92208 9.60763C1.19197 9.60763 0.600098 9.01576 0.600098 8.28565ZM0.600098 14.4549C0.600098 13.7248 1.19197 13.1329 1.92208 13.1329C2.65219 13.1329 3.24406 13.7248 3.24406 14.4549C3.24406 15.185 2.65219 15.7769 1.92208 15.7769C1.19197 15.7769 0.600098 15.185 0.600098 14.4549ZM5.00669 8.28565C5.00669 7.79891 5.40127 7.40433 5.88801 7.40433H15.5825C16.0693 7.40433 16.4638 7.79891 16.4638 8.28565C16.4638 8.77239 16.0693 9.16697 15.5825 9.16697H5.88801C5.40127 9.16697 5.00669 8.77239 5.00669 8.28565ZM5.00669 14.4549C5.00669 13.9681 5.40127 13.5736 5.88801 13.5736H15.5825C16.0693 13.5736 16.4638 13.9681 16.4638 14.4549C16.4638 14.9416 16.0693 15.3362 15.5825 15.3362H5.88801C5.40127 15.3362 5.00669 14.9416 5.00669 14.4549Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
